/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatStepperModule } from '@angular/material/stepper';
import { UserDetailComponent } from '@app/user/user-detail/user-detail.component';
import { AppointmentsModule } from '@appointments/appointments.module';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { SharedModule } from '@shared/shared.module';
import { AngularSplitModule } from 'angular-split';
import { NgxPermissionsModule } from 'ngx-permissions';
import { TranslateRolesPipe } from './pipes/translate-roles.pipe';
import { UserDeactivationConfirmationComponent } from './user-deactivation-confirmation/user-deactivation-confirmation.component';
import { UserListComponent } from './user-list/user-list.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { UserSearchComponent } from './user-search/user-search.component';

@NgModule({
    declarations: [
        UserListComponent,
        UserDetailComponent,
        UserProfileComponent,
        TranslateRolesPipe,
        UserSearchComponent,
        UserDeactivationConfirmationComponent
    ],
    exports: [
        UserListComponent,
        UserSearchComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        MatButtonModule,
        MatDialogModule,
        MatIconModule,
        MatInputModule,
        MatFormFieldModule,
        NgxPermissionsModule,
        MatProgressSpinnerModule,
        MatStepperModule,
        FlexLayoutModule,
        SharedModule,
        AngularSplitModule,
        AppointmentsModule,
    ]
})
export class UserModule { }
